"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _editorialContentGrid = _interopRequireDefault(require("../styles/editorial-content-grid.css"));
var _editorialContentGrid2 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.defaultProps"));
var _editorialContentGrid3 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.propTypes"));
var _commonRichText = require("@mmc/common-rich-text");
var dataUtils = new _mmcDataUtilities["default"]();
var renderEmptyString = dataUtils.renderEmptyString,
  handleNestedProp = dataUtils.handleNestedProp;
var modulo = 3;
var TextBlockWrapper = function TextBlockWrapper(_ref) {
  var text = _ref.text,
    theme = _ref.theme,
    index = _ref.index,
    disclaimerData = _ref.disclaimerData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialContentGrid["default"].textWrapper + " " + ((index + 1) % modulo === 0 && _editorialContentGrid["default"].lastColumn)
  }, renderEmptyString(text.sectionHeading) !== ' ' && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: text.sectionHeading,
    className: theme.labelMedium + " " + theme.marginBottom20 + " " + _editorialContentGrid["default"].greyButton,
    tag: "h2",
    disclaimerData: disclaimerData
  }), renderEmptyString(text.mainHeading) !== ' ' && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: text.mainHeading,
    className: theme.headingFour + " " + theme.marginBottom20 + " " + _editorialContentGrid["default"].disclaimerButton,
    tag: "h3",
    disclaimerData: disclaimerData
  }), renderEmptyString(text.paragraph) !== ' ' && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      html: handleNestedProp(text, 'text.paragraph')
    }),
    disclaimerData: disclaimerData,
    className: theme.bodyCopy + " " + _editorialContentGrid["default"].greyButton
  }));
};
TextBlockWrapper.displayName = 'TextBlockWrapper';
TextBlockWrapper.defaultProps = {
  text: _editorialContentGrid2["default"].columns[0].description,
  index: 0
};
var _default = TextBlockWrapper;
exports["default"] = _default;